import { Skeleton } from '../skeleton';

/**
 * 顧客リストのスケルトンUI
 * @param count - 表示するスケルトンアイテムの数（デフォルト: 5）
 */
export function CustomerListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <ul className="divide-y divide-stone-200">
      {Array.from({ length: count }).map((_, index) => (
        <li
          key={index}
          className="gap-sm px-lg h-(--h-list) relative flex flex-col justify-center"
        >
          <div className="gap-md flex items-center">
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-7 w-40 absolute end-0 top-0" />
            <Skeleton className="h-5 w-12" />
            <Skeleton className="h-5 w-16" />
            <div className="gap-sm flex">
              <Skeleton className="h-5 w-8" />
              <Skeleton className="h-5 w-8" />
              <Skeleton className="h-5 w-8" />
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="gap-sm flex items-center">
              <Skeleton className="h-12 w-12 rounded" />
              <div className="space-y-sm">
                <Skeleton className="h-6 w-32" />
                <Skeleton className="h-4 w-48" />
              </div>
            </div>
            <div className="gap-md flex items-center">
              <Skeleton className="h-12 w-12 rounded-full" />
              <Skeleton className="h-12 w-12 rounded-full" />
              <Skeleton className="h-12 w-12 rounded-full" />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
